// extracted by mini-css-extract-plugin
export default {"paddedButton":"BulkDisbursementPage_paddedButton__6dqm3","page":"BulkDisbursementPage_page__vaVIu"};